import { render } from "./Magazine.vue?vue&type=template&id=ce42d634&scoped=true"
import script from "./Magazine.vue?vue&type=script&lang=js"
export * from "./Magazine.vue?vue&type=script&lang=js"

import "./Magazine.vue?vue&type=style&index=0&id=ce42d634&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce42d634"]])

export default __exports__